module.exports = __webpack_public_path__ + "img/active_ad_bg.3af729a2.png";